import { Button, IconButton, TableCell, withStyles } from '@material-ui/core';
import React from 'react';
export const SLOTTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        padding: '8px 8px',
        borderTop: '1px solid #EBEDF8',
        borderBottom: '1px solid #EBEDF8',
        '&:first-child': {
            paddingLeft: '16px',
            borderTopLeftRadius: '4px',
            borderBottomLeftRadius: '4px',
            borderLeft: '1px solid #EBEDF8',
        },
        '&:last-child': {
            paddingRight: '16px',
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px',
            borderRight: '1px solid #EBEDF8',
        },
    },
}))(TableCell);
export const SLOTTableHeadCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: '#525050',
        fontWeight: 700,
        fontSize: 16,
        letterSpacing: '0.144px',
        textTransform: 'capitalize',
        padding: '8px',
        borderBottom: 'none',
        //textAlign: 'center',
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

export const SlotIcon = withStyles(() => ({
    root: {
        border: '1px solid transparent',
        '&:hover': {
            backgroundColor: '#fff !important',
            border: '1px solid #c7c6e2 !important',
        },
    },
    rootDelete: {
        color: 'red',
        border: '1px solid transparent',
        '&:hover': {
            border: '1px solid #c7c6e2',
            backgroundColor: 'red',
            color: '#fff',
        },
    },
}))(({ classes, isDelete, useButton = false, ...props }: any) =>
    !!useButton ? (
        <Button
            classes={{
                root: !!isDelete ? classes.rootDelete : classes.root,
            }}
            {...props}
        >
            {props.children}
        </Button>
    ) : (
        <IconButton
            classes={{
                root: !!isDelete ? classes.rootDelete : classes.root,
            }}
            {...props}
        >
            {props?.children}
        </IconButton>
    ),
);
